export default {
  warning:
    'Acest local nu este asociat unui brand. Pentru ca sistemul să funcționeze corect, localul trebuie să aparțină unuia. Vă rugăm adăugați acest local la un brand.',
  cta: 'Mergi la branduri',
};
